import './inspiration.css';
import Swiper from 'swiper';

export default (element) => {
  const init = () => {
    const sliderDiv = element.querySelector('[data-inspiration]');
    const slides = element.querySelectorAll('[data-inspiration-slide]');
    const sliderPrev = element.querySelector('[data-inspiration-prev]');
    const sliderNext = element.querySelector('[data-inspiration-next]');

    // eslint-disable-next-line
    const slider = new Swiper(sliderDiv, {
      slidesPerView: slides.length > 4 ? 4 : slides.length,
      centeredSlides: false,
      slideWidth: 58,
      spaceBetween: 12,
      navigation: {
        prevEl: sliderPrev,
        nextEl: sliderNext,
      },
      breakpoints: {
        1024: {
          spaceBetween: 20,
          slideWidth: 100,
        },
      },
    });
  };

  init();
};
